import React, { useState } from 'react';
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import {
    TextField,
    Button,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Grid,
    Paper,
    Typography
} from '@material-ui/core';
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from "../redux/actions/appAction";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    button: {
        marginTop: theme.spacing(2),
    },
    formRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    formItem: {
        flex: 1,
        marginRight: theme.spacing(2),
    },
    formItemLast: {
        flex: 1,
    },
}));

const CreateProject = (props) => {
    const classes = useStyles();
    const [formData, setFormData] = useState({
        project_type_name: '',
        projectNumber: '',
        clientName: '',
        clientAddress: '',
        expectedDeliveryDate: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "clientName" && !/^[a-zA-Z\s]*$/.test(value)) {
            return;
        }
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
		props.setLoading(true);
        try {
            const RESPONSE = await HttpService.createProject(formData);
            if(RESPONSE.status === 200) {
                props.setSnackInfo('Project Created Successfully!', 'success');
            } else {
                props.setSnackInfo(RESPONSE?.data ?? "Something went wrong", "error");
            }
        } catch (err) {
            console.log('err: ', err.message);
            console.error(err);
            if (err.response && err.response.status === 409) {
                props.setSnackInfo(err.response.data.message ?? "Conflict: Project already exists", "error");
            } else {
                props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
            }
        }
		props.setLoading(false);
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Typography variant="h5" component="h2" gutterBottom>
                    Create Project
                </Typography>
                <form onSubmit={handleSubmit}>
                    <div className={classes.formRow}>
                        <FormControl fullWidth className={`${classes.formControl} ${classes.formItem}`}>
                            <InputLabel>Project Type</InputLabel>
                            <Select
                                name="project_type_name"
                                value={formData.project_type_name}
                                onChange={handleChange}
                            >
                                <MenuItem value="Capex">Capex</MenuItem>
                                <MenuItem value="Overhead">Overhead</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth
                            label="Project Number"
                            name="projectNumber"
                            value={formData.projectNumber}
                            onChange={handleChange}
                            className={classes.formItem}
                        />
                        <TextField
                            fullWidth
                            label="Client Name"
                            name="clientName"
                            value={formData.clientName}
                            onChange={handleChange}
                            className={classes.formItem}
                        />
                        <TextField
                            fullWidth
                            label="Client Address"
                            name="clientAddress"
                            value={formData.clientAddress}
                            onChange={handleChange}
                            className={classes.formItem}
                        />
                        <TextField
                            fullWidth
                            label="Expected Delivery Date"
                            name="expectedDeliveryDate"
                            type="date"
                            value={formData.expectedDeliveryDate}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.formItemLast}
                        />
                    </div>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        disabled={
                            formData.project_type_name === '' ||
                            formData.projectNumber === '' ||
                            formData.clientName === '' ||
                            formData.clientAddress === '' ||
                            formData.expectedDeliveryDate === ''
                        }
                    >
                        Create Project
                    </Button>
                </form>
            </Paper>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(CreateProject);